"use client";

import { c as _c } from "react/compiler-runtime";
import { IconLayersThree } from "central-icons/IconLayersThree";
import { useReducedMotion } from "motion/react";
import { useRef } from "react";
import DemoFooter from "@/components/preview/demo-footer";
import DemoWrapper from "@/components/preview/demo-wrapper";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const NAV_ITEMS = ["Home", "Articles", "About"];
const PARAGRAPH_BARS = [{
  id: "line-1",
  width: "w-full"
}, {
  id: "line-2",
  width: "w-11/12"
}, {
  id: "line-3",
  width: "w-4/5"
}, {
  id: "line-4",
  width: "w-full"
}, {
  id: "line-5",
  width: "w-3/5"
}, {
  id: "line-6",
  width: "w-full"
}, {
  id: "line-7",
  width: "w-5/6"
}, {
  id: "line-8",
  width: "w-11/12"
}, {
  id: "line-9",
  width: "w-2/3"
}];
export default function AccessibilitySkipLinkDemo() {
  const $ = _c(11);
  const skipRef = useRef(null);
  const scrollRef = useRef(null);
  const headingRef = useRef(null);
  const reducedMotion = useReducedMotion();
  let t0;
  if ($[0] !== reducedMotion) {
    t0 = () => {
      const container = scrollRef.current;
      const heading = headingRef.current;
      if (!(container && heading)) {
        return;
      }
      const margin = Number.parseFloat(getComputedStyle(heading).scrollMarginTop) || 0;
      container.scrollTo({
        behavior: reducedMotion ? "auto" : "smooth",
        top: heading.offsetTop - margin
      });
      heading.focus({
        preventScroll: true
      });
    };
    $[0] = reducedMotion;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activate = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DemoFooter className="z-30" position="top"><Button onClick={() => skipRef.current?.focus()} rounded={true} size="sm" type="button">Focus the skip link</Button></DemoFooter>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== activate) {
    t2 = <a className="absolute top-4 left-2 z-20 -translate-y-4 rounded-full bg-gray-1200 px-3.5 py-1.5 font-medium text-gray-100 text-sm opacity-0 shadow-custom outline-none ring-sky-400 transition-[translate,opacity] duration-200 ease-out focus:translate-y-0 focus:opacity-100 focus:ring-2 motion-reduce:transition-none" href="#cheat-sheet-skip-target" onClick={event => {
      event.preventDefault();
      activate();
    }} ref={skipRef}>Skip to content</a>;
    $[3] = activate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <nav aria-label="Demo page" className="sticky top-0 z-10 flex items-center gap-4 border-preview-border border-b bg-gray-100 px-4 py-2.5"><span aria-hidden="true" className="size-3.5 rounded-full bg-gray-1200" />{NAV_ITEMS.map(_temp)}</nav>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div aria-hidden="true" className="mx-4 mt-4 flex h-64 items-center justify-center rounded-lg border border-gray-400 border-dashed bg-gray-200"><div className="flex size-10 items-center justify-center rounded-lg bg-gray-100 shadow-custom"><IconLayersThree className="size-6 text-gray-800" /></div></div>;
    t5 = <h3 className="scroll-mt-12 rounded-sm px-4 pt-4 font-semibold text-base text-gray-1200 outline-none focus:outline-2 focus:outline-sky-400 focus:outline-offset-4" id="cheat-sheet-skip-target" ref={headingRef} tabIndex={-1}>Main content</h3>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="relative h-96 w-full overflow-y-auto overscroll-contain" ref={scrollRef}>{t3}{t4}{t5}<div aria-hidden="true" className="flex flex-col gap-2.5 px-4 py-4">{PARAGRAPH_BARS.map(_temp2)}</div></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2) {
    t7 = <DemoWrapper margin="">{t1}<div className="relative w-full">{t2}{t6}</div></DemoWrapper>;
    $[9] = t2;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
function _temp2(t0) {
  const {
    id,
    width
  } = t0;
  return <div className={cn("h-3 rounded-sm bg-gray-300", width)} key={id} />;
}
function _temp(item) {
  return <button className="rounded-sm text-gray-1100 text-sm outline-none transition-colors duration-150 ease-out hover-hover:hover:text-gray-1200 focus-visible:outline-2 focus-visible:outline-sky-400" key={item} type="button">{item}</button>;
}